import React from 'react';
import PropTypes from 'prop-types';

import { withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import DesktopNav from './Components/DesktopNav/DesktopNav.jsx';
import MobileNav from './Components/MobileNav/MobileNav.jsx';
import FsDesktopNav from './Components/FsDesktopNav/FsDesktopNav.jsx';
import FsMobileNav from './Components/FsMobileNav/FsMobileNav.jsx';


export const MainNav = (
    {
        headerContext = {},
        sitecoreContext: { globalContent = {},site={}, viewBag = {} },
        ...props
    }
) => {

    if (site.name === 'bushs-beans-foodservices') {
        return (
            <>
                <FsMobileNav className={site.name} {...props} />
                <FsDesktopNav className={site.name} {...props} />
            </>
        );
    } else {
        return (
            <>
                <MobileNav className={site.name} {...props} />
                <DesktopNav className={site.name} {...props} />
            </>
        );
    }
};

MainNav.propTypes = {
    headerContext: PropTypes.object,
    sitecoreContext: PropTypes.object,
};

export default withSitecoreContext()(MainNav);